import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-flexbox-grid';
import Color from 'constants/colors'
import FillWithLine from 'pages/june-5/components/text-and-line'
import {LinkOutIcon, LinkOutStyle} from 'components/static/icons'
import {Spacer} from 'layout/util'

const Title = styled.h2`
	display: inline-block;
	color: #333;
`;

const SubsectionTitle = styled.h4`
	color: #666;
	margin-bottom: 10px;
`;

const ExternalLink = styled.a`
	font-family: ${props=>props.theme.fonts.h3};
	display: block;
	color: ${Color('purple')};
	margin-top: 8px;
`;

const SectionWrapper = styled.div`
	margin: 0 auto;
	margin-bottom: 30px;
	@media screen and (max-width: 767px) {
		text-align: center;
	}
`;

const BlockWrapper = styled.div`
	@media print {
		display: none;
	}
`;

const SectionSubtitle = styled.div`
	font-style: italic;
	font-size: 14px;
	margin-bottom: 30px;
`;

const LinksChunk = (props) => {
	const links = props.data.links.map( (link, j) => {
		return(
			<React.Fragment key={j}>
			 <ExternalLink target="_blank" rel="noopener noreferrer" href={link.url}><LinkOutStyle><LinkOutIcon/></LinkOutStyle>{link.text}</ExternalLink>
			</React.Fragment>
		)
	})
	return(
		<SectionWrapper>
			<SubsectionTitle>{props.data.subsectionTitle}</SubsectionTitle>
			{links}
		</SectionWrapper>
	);
}

const LinksBlock = (props) => {
	const evenSections = props.data.subsections.map( (section, i) => {
		if(i%2===0) {
			return( <LinksChunk key={i} data={section} /> );
		}
		return null;
	})
	//-- to make two columns
	const oddSections = props.data.subsections.map( (section, i) => {
		if(i%2===1) {
			return( <LinksChunk key={i} data={section} /> );
		}
		return null;
	})


	return(
		<BlockWrapper>
			<Row>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={1} sm={10} 
		      mdOffset={1} md={10} 
		      lgOffset={1} lg={10}
		    >
		    	<Spacer height={70} />
		    	<FillWithLine>
				  	<Title>More reading</Title>
		    	</FillWithLine>
					<SectionSubtitle>Other articles, analyses, and opinions. Let us know if there's another perspective we should include: hi@bythebay.cool.</SectionSubtitle>

			  </Col>
		  </Row>
			<Row>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={4} sm={4} 
		      mdOffset={3} md={3} 
		      lgOffset={3} lg={3}
		    >
		    	{evenSections}
				</Col>
		    <Col 
		    	xsOffset={1} xs={10} 
		      smOffset={4} sm={4} 
		      mdOffset={0} md={3} 
		      lgOffset={0} lg={3}
		    >
		    	{oddSections}
				</Col>
			</Row>
		</BlockWrapper>
	);
}

export default LinksBlock


// WEBPACK FOOTER //
// ./src/pages/june-5/props/components/LinksBlock.js